<div class="content">
  <ng-template #selectVessel>
    <h1>Please select a vessel</h1>
  </ng-template>

  <div class="date-picker-container">
    <div class="wrapper align-items-center flex flex-wrap gap-inner justify-content-between">
      <div *ngIf="getSelectedVesselId(); else selectVessel">
        <h1>{{ getVesselName() }}</h1>
      </div>
    </div>
    <div id="webix-fm" [ngClass]="{ 'webix-element': true, spinner: showSpinner }"></div>
  </div>
</div>
